var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabHomeFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2703 24H20C21.6569 24 23 22.6569 23 21V9.27766C23 8.92272 22.8134 8.59526 22.5092 8.41246C21.4787 7.79329 19.0567 6.30748 17.5 5.10637C15.8559 3.83778 13.8017 1.82556 12.7291 0.744777C12.3281 0.340734 11.6719 0.340734 11.2709 0.744777C10.1983 1.82556 8.14413 3.83778 6.5 5.10637C4.94333 6.30748 2.52128 7.79329 1.4908 8.41246C1.18655 8.59526 1 8.92272 1 9.27766V21C1 22.6569 2.34314 24 4 24H7.72973C8.28202 24 8.72973 23.5523 8.72973 23V15.7987C8.72973 13.9926 10.1939 12.5285 12 12.5285C13.8061 12.5285 15.2703 13.9926 15.2703 15.7987V23C15.2703 23.5523 15.718 24 16.2703 24Z",
    fill: "currentColor",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabHomeFilled);
export default __webpack_public_path__ + "static/media/tab_home_filled.82fd7e1d.svg";
export { ForwardRef as ReactComponent };